import { render, staticRenderFns } from "./DashBoardWalletsManagementView.vue?vue&type=template&id=50fae951&scoped=true&"
import script from "./DashBoardWalletsManagementView.vue?vue&type=script&lang=js&"
export * from "./DashBoardWalletsManagementView.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardWalletsManagementView.vue?vue&type=style&index=0&id=50fae951&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fae951",
  null
  
)

export default component.exports